import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { ConfirmPopup, ConfirmPopupModule } from 'primeng/confirmpopup';
import { IndicatorsService } from '../../services/indicators.service';
import { ToastrService } from 'ngx-toastr';
import { DirectionService } from '../../services/direction.service';
import { forkJoin, Subject, switchMap, takeUntil } from 'rxjs';
import { CommonModule } from '@angular/common';
import { GoalService } from '../../services/goal.service';
import { Goal } from '../../interfaces/models/goal.model';

@Component({
  selector: 'app-goals-indicators',
  standalone: true,
  imports: [TranslateModule, RouterModule, ConfirmPopupModule, ButtonModule, CommonModule],
  templateUrl: './goals-indicators.component.html',
  styleUrl: './goals-indicators.component.scss',
  providers: [ConfirmationService],
})
export class GoalsIndicatorsComponent implements OnInit {
  @ViewChild(ConfirmPopup) confirmPopup!: ConfirmPopup;
  unsubscribe$ = new Subject<any>();
  indicators = [] as any[]
  dir!: 'rtl' | 'ltr';
  strategyId = 0
  goalId = 0
  hoverIndicatorId = 0
  goal = {} as Goal;
  constructor(
    private confirmationService: ConfirmationService,
    private indicatorsService: IndicatorsService,
    private goalsService: GoalService,
    private toastr: ToastrService,
    private directionService: DirectionService,
    private route: ActivatedRoute
  ) {


  }
  ngOnInit(): void {
    this.directionService.direction$.subscribe((dir) => {
      this.dir = dir;
    })

    this.route.data.pipe(takeUntil(this.unsubscribe$))
      .subscribe(({ viewBag }) => {
        this.indicators = viewBag.indicators['data']['indicators'];
        this.goal = viewBag.goal['data']['goal'];
      })

    this.route.queryParams.pipe(takeUntil(this.unsubscribe$)).subscribe((params: any) => {
      const { strategyId, goalId } = params;
      this.strategyId = +strategyId;
      this.goalId = +goalId;
    })


  }
  confirmIndicatorDelete(event: Event, indiactorId: number) {
    event.stopPropagation();
    const target = event.target as HTMLElement;
    this.confirmationService.confirm({
      target: target,
      message: this.dir == 'rtl' ? 'هل تريد تأكيد المسح؟' : 'Do you want to confirm the deletion?',
      accept: () => {
        this.indicatorsService.deleteIndicator(0, indiactorId).subscribe(() => {
          this.indicators = this.indicators.filter(x => x.id != indiactorId);
          this.toastr.success(this.dir == 'rtl' ? 'تمت المسح ' : 'The indicator has been deleted successfully.', this.dir == 'rtl' ? 'عملية ناجحة' : 'Success');
        })
      },
      reject: () => {
        this.toastr.info(this.dir == 'rtl' ? "تم الالغاء" : "The deletion has been canceled.", this.dir == 'rtl' ? 'الغاء' : 'Canceled');
      }
    });
  }
  accept() {
    this.confirmPopup.accept();
  }
  reject() {
    this.confirmPopup.reject();
  }

  onMouseEnter(hoverIndicatorId: number) {
    this.hoverIndicatorId = hoverIndicatorId;
  }
  onMouseLeave() {
    this.hoverIndicatorId = 0;
  }
  goBack() {
    window.history.back();
  }
}
